import { render } from "./ProductGridWithFeatured.vue?vue&type=template&id=6a4f191c&scoped=true"
import script from "./ProductGridWithFeatured.vue?vue&type=script&lang=js"
export * from "./ProductGridWithFeatured.vue?vue&type=script&lang=js"

import "./ProductGridWithFeatured.vue?vue&type=style&index=0&id=6a4f191c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a4f191c"]])

export default __exports__